import { FluidTableHeader } from '@lmig/fluid-core';

import { FluidTable } from '../../fluid-table';
import { FluidTableHelper } from '../../helpers/fluid-table-helper.interface';

export class FluidTableFilterResetHelper implements FluidTableHelper {
  host: FluidTable;

  constructor(tableInstance: FluidTable) {
    this.host = tableInstance;
  }

  /**
   * Resets the filter menus depending on type - if search (combo-box), reset the
   * search and trigger the value change event to update the filters, or if default/custom,
   * reset the toggles.
   * @param header
   */
  async resetFilterMenu(header: FluidTableHeader) {
    header.type === 'date'
      ? await this.resetDateFilters(header)
      : header.enableColumnSearch
      ? await this.resetColumnSearch(header)
      : await this.resetColumnFilters(header);
  }

  /**
   * Reset column filters on a particular header
   * @param header
   */
  async resetColumnFilters(header: FluidTableHeader) {
    return (
      this.host._filterMenus[header.dataPath] as HTMLFluidContextMenuElement
    )?.resetToggles(true);
  }

  /**
   * Reset date filters on a particular header
   * @param header
   */
  async resetDateFilters(header: FluidTableHeader) {
    return (
      this.host._filterMenus[header.dataPath] as HTMLFluidDateRangeElement
    )?.reset();
  }

  /**
   * Reset column search on a particular header
   * @param host
   * @param header
   */
  async resetColumnSearch(header: FluidTableHeader) {
    return (this.host._filterMenus[header.dataPath] as HTMLFluidComboBoxElement)
      ?.reset(true)
      .then(() =>
        (
          this.host._filterMenus[header.dataPath] as HTMLFluidComboBoxElement
        ).triggerValueChange()
      );
  }
}
